module.exports = new __parcel__URL__("julekalender_header.30ce0cee.png").toString();